import React, { useState } from 'react';
import { Tabs, Tab, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import VerificationRequest from '../VerificationRequest/VerificationRequest';

const VerificationTabs = ({ data, onApprove, onReject }) => {
  const [activeKey, setActiveKey] = useState('pending');
  const [rejecting, setRejecting] = useState(null);
  const [reason, setReason] = useState('');

  const openRejectModal = (request) => {
    setRejecting(request);
    setReason('Запрос отклонен');
  };

  const handleRejectConfirm = () => {
    if (!rejecting) return;
    onReject?.(rejecting, reason);
    setRejecting(null);
    setReason('');
  };

  return (
    <>
      <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k || 'pending')} className="mb-3">
        <Tab eventKey="pending" title={`Новые заявки (${data.pending.length})`}>
          <Row className="g-3">
            {data.pending.map((req) => (
              <Col xs={12} md={6} lg={4} key={req._id}>
                <VerificationRequest
                  request={req}
                  onApprove={() => onApprove?.(req)}
                  onReject={() => openRejectModal(req)}
                />
              </Col>
            ))}
            {data.pending.length === 0 && <div className="text-muted">Нет новых заявок</div>}
          </Row>
        </Tab>
        <Tab eventKey="approved" title={`Одобренные (${data.approved.length})`}>
          <Row className="g-3">
            {data.approved.map((req) => (
              <Col xs={12} md={6} lg={4} key={req._id}>
                <VerificationRequest request={req} readonly />
              </Col>
            ))}
            {data.approved.length === 0 && <div className="text-muted">Нет одобренных заявок</div>}
          </Row>
        </Tab>
        {/* <Tab eventKey="rejected" title={`Отклонённые (${data.rejected.length})`}>
          <Row className="g-3">
            {data.rejected.map((req) => (
              <Col xs={12} md={6} lg={4} key={req._id}>
                <VerificationRequest request={req} readonly />
              </Col>
            ))}
            {data.rejected.length === 0 && <div className="text-muted">Нет отклонённых заявок</div>}
          </Row>
        </Tab> */}
      </Tabs>

      <Modal show={Boolean(rejecting)} onHide={() => setRejecting(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Причина отказа</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Причина</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Укажите причину, которая будет отправлена пользователю"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setRejecting(null)}>
            Отмена
          </Button>
          <Button variant="danger" disabled={reason.length < 3} onClick={handleRejectConfirm}>
            Отклонить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VerificationTabs;

